"use client";

import React from "react";
import { getMatchDisplayTime } from "@/utils/matchInfo";

export default function CarouselMatchTime({
  liveScore,
  status,
  matchTime,
  halfStartTime,
  className = "",
  isLive = false
}) {
  const displayTime = getMatchDisplayTime(liveScore, status, matchTime, halfStartTime);

  if (displayTime.type === 'var') {
    return <span className={className}>VAR</span>;
  }

  if (displayTime.type === 'minute') {
    return (
      <span className={className}>
        {displayTime.content}
        <span className="animate-pulse">&apos;</span>
      </span>
    );
  }

  return (
    <span className={className}>
      {displayTime.content}
    </span>
  );
}
